module.exports = __webpack_public_path__ + "img/logo_jd.0db58f33.png";